import React from 'react';

import { routes } from '@aline/routes';
import { Helmet } from 'react-helmet';
import { Route, Routes } from 'react-router-dom';
import { ContentWrapper, ReportPage, ReportsList } from 'src/components';
import { Apollo } from 'src/gql/generated';
import { createRelativeRouter } from 'src/helpers/router-helpers';

const { toRelativePath: toRelativeReportsPath } = createRelativeRouter(routes.ReportIndex, {
  nestedRoutes: true,
});

export function Reports(): JSX.Element {
  // Subscribe to AI reminder automation updates for all Reports in the Org.
  Apollo.useOnAiReminderAutomationUpdatedSubscription({ ignoreResults: true });

  /**
   * No `location` prop: a string location replaces the one routes below read, so passing the
   * pathname dropped the query and the report never saw its `scrollToDoc` deep link.
   */
  return (
    <>
      <Helmet>
        <title>Reports</title>
      </Helmet>
      <Routes>
        <Route
          element={
            <ContentWrapper>
              <ReportsList />
            </ContentWrapper>
          }
          path={toRelativeReportsPath(routes.ReportIndex)}
        />
        <Route element={<ReportPage />} path={toRelativeReportsPath(routes.ReportDetail)} />
      </Routes>
    </>
  );
}
